module.exports = __webpack_public_path__ + "assets/img/Type BS (8).a3db69ae.jpg";